<template>
  <div class="vh-100">
    <CustomerHeader />
    <div class="px-4 mt-2 h-100">
      <p class="header-title h4">customer orders</p>

      <template v-for="item in customerOrdersList">
        <OrderCard :key="item.id" :orderObject="item" />
      </template>
      <template v-if="customerOrdersList.length===0">
        <div class="d-flex align-items-center h-75 justify-content-center">
          <p>No orders yet!</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import OrderCard from "../customer/OrderCard";
import CustomerHeader from "../customer/customerHeader";
export default {
  components: {
    OrderCard,
    CustomerHeader
  },
  methods: {
    ...mapActions({
      customerOrders: "Order/customerOrders"
    }),
    async fetchMenu() {
      const response = await this.$store.dispatch("MenuView/getCurrentMenu", {
        username: this.username,
        menu_slug: this.menu_slug
      });
    }
  },
  computed: {
    menu() {
      return this.$store.state.MenuView.currentMenu;
    },
    currentCompany() {
      return this.$store.state.MenuView.currentCompany;
    },
    customerOrdersList() {
      return this.$store.state.Order.customerOrders;
    }
  },
  mounted() {
    this.username = this.$route.params.username;
    this.menu_slug = this.$route.params.menu_slug;
    this.fetchMenu().then(() => {
      this.customerOrders({ limit: 20, companyId: this.currentCompany.id });
    });
  }
};
</script>

<style>
</style>